import { Spinner } from "@silversea-ssc/ui-components-react"
import React from "react"
import styles from "./SectionLoader.module.scss"

const SectionLoader: React.FC<React.PropsWithChildren<unknown>> = () => {
    return (
        <div className={styles.container}>
            <Spinner size="large" color="neutral10" />
        </div>
    )
}

export default SectionLoader
